export default __webpack_public_path__ + "static/bg-acadmy-7d844dadd3886eae772b7fa67fcbc69c.png";